export const GET_NUTRITION_PLANS_SUCCEEDED = 'NutritionPlans/GET_SUCCEEDED';
export const GET_NUTRITION_PLANS_ERROR = 'NutritionPlans/GET_ERROR';

export const GET_CLIENT_NUTRITION_PLANS_SUCCEEDED =
  'ClientNutritionPlans/GET_SUCCEEDED';
export const GET_CLIENT_NUTRITION_PLANS_ERROR =
  'ClientNutritionPlans/GET_ERROR';

export const GET_NUTRITION_PLAN_SUCCEEDED = 'NutritionPlan/GET_SUCCEEDED';
export const GET_NUTRITION_PLAN_ERROR = 'NutritionPlan/GET_ERROR';

export const ASSIGN_CLIENT_TO_PLANS_SUCCEEDED =
  'NutritionPlan/ASSIGN_CLIENT_SUCCEEDED';
export const ASSIGN_CLIENT_TO_PLANS_ERROR = 'NutritionPlan/ASSIGN_CLIENT_ERROR';

export const ASSIGN_PLAN_TO_CLIENTS_SUCCEEDED =
  'NutritionPlan/ASSIGN_PLAN_SUCCEEDED';
export const ASSIGN_PLAN_TO_CLIENTS_ERROR = 'NutritionPlan/ASSIGN_PLAN_ERROR';

export const RENAME_PLAN_SUCCEEDED = 'NutritionPlan/RENAME_PLAN_SUCCEEDED';
export const RENAME_PLAN_ERROR = 'NutritionPlan/RENAME_PLAN_ERROR';

export const CREATE_PLAN_SUCCEEDED = 'NutritionPlan/CREATE_PLAN_SUCCEEDED';
export const CREATE_PLAN_ERROR = 'NutritionPlan/CREATE_PLAN_ERROR';

export const DELETE_PLAN_SUCCEEDED = 'NutritionPlan/DELETE_PLAN_SUCCEEDED';
export const DELETE_PLAN_ERROR = 'NutritionPlan/DELETE_PLAN_ERROR';

export const UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED =
  'NutritionPlan/UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED';
export const UNASSIGN_CLIENT_FROM_PLAN_ERROR =
  'NutritionPlan/UNASSIGN_CLIENT_FROM_PLAN_ERROR';

export const CREATE_MEAL_SUCCEEDED = 'NutritionPlan/CREATE_MEAL_SUCCEEDED';
export const CREATE_MEAL_ERROR = 'NutritionPlan/CREATE_MEAL_ERROR';

export const EDIT_MEAL_SUCCEEDED = 'NutritionPlan/EDIT_MEAL_SUCCEEDED';
export const EDIT_MEAL_ERROR = 'NutritionPlan/EDIT_MEAL_ERROR';

export const SEARCH_FOOD_SUCCEEDED = 'NutritionPlan/SEARCH_FOOD_SUCCEEDED';
export const SEARCH_FOOD_ERROR = 'NutritionPlan/SEARCH_FOOD_ERROR';

export const CREATE_FOOD_SUCCEEDED = 'NutritionPlan/CREATE_FOOD_SUCCEEDED';
export const CREATE_FOOD_ERROR = 'NutritionPlan/CREATE_FOOD_ERROR';
export const LOADING_FOOD = 'NutritionPlan/LOADING_FOOD';
export const NUTRATION_LOADING_STATE = 'NutritionPlan/NUTRATION_LOADING_STATE';
export const CURRENT_NUTRATION_LOADING_STATE = 'NutritionPlan/CURRENT_NUTRATION_LOADING_STATE';
export const CLIENT_NUTRATION_LOADING_STATE = 'NutritionPlan/CLIENT_NUTRATION_LOADING_STATE';

export const GET_MEASUREMENTS_SUCCEEDED = 'NutritionPlan/GET_MEASUREMENTS_SUCCEEDED';
export const GET_MEASUREMENTS_ERROR = 'NutritionPlan/GET_MEASUREMENTS_ERROR';
export const LOADING_MEASUREMENTS = 'NutritionPlan/LOADING_MEASUREMENTS';

export const DELETE_MEAL_SUCCEEDED = 'NutritionPlan/DELETE_MEAL_SUCCEEDED';
export const DELETE_MEAL_ERROR = 'NutritionPlan/DELETE_MEAL_ERROR';